// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '../store/index'
import {
	ERR,
	INFO,
	LOG,
	WARN
} from '@/uitlis/errorLog'
import tbstore from '../src/uitlis/store'
import 'babel-polyfill'
//svg
import './style/init.css'
import './assets/iconfont/iconfont.css'
import './api/aliplayercomponents-1.0.1.min'
//装载vuex
// import store from "./store";
// 一键复制文本
import clipboard from 'clipboard';

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$tbstore = tbstore
Vue.prototype.$err = ERR
Vue.prototype.$info = INFO
Vue.prototype.$log = LOG
Vue.prototype.$warn = WARN
Vue.prototype.clipboard = clipboard

Vue.prototype.couponStatus = {
	setCoupon(majorIdKey, status) {
		console.log(majorIdKey);
		console.log(status);
		localStorage.setItem(majorIdKey, status)
	},
	getCoupon(majorIdKey) {
		return localStorage.getItem(majorIdKey)
	},
}

// 手机号中间四位*处理
Vue.prototype.getUserPhone = function(phone) {
	var pattern = /^1[3456789]\d{9}$/;
	if (pattern.test(phone)) {
		var encryptPhone = phone.substr(0, 3) + '****' + phone.substr(7)
		return encryptPhone;
	}
	return phone;
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	// store:store,
	components: {
		App
	},
	template: '<App/>'
})

//点击图片变大,旋转等...
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
	defaultOptions: {
		zIndex: 9999
	}
})



// WEBPACK FOOTER //
// ./src/main.js